"use strict";

/**
 * @ngdoc overview
 * @name ntmApp
 * @description
 * # ntmApp
 *
 * Main module of the application.
 */

angular
  .module("ntmApp", [
    "ngAnimate",
    "ngCookies",
    "ngResource",
    "ngRoute",
    "ngSanitize",
    "ui.grid",
    "ui.grid.edit",
    "ui.grid.rowEdit",
    "ui.grid.cellNav",
    "ui.grid.exporter",
    "ui.grid.selection",
    "ui.grid.pagination",
    "ui.grid.draggable-rows",
    "ui.grid.grouping",
    "ui.grid.resizeColumns",
    "ui.bootstrap",
    "ui.tinymce",
    "dndLists",
    "schemaForm",
    "ngMaterial",
    "angular-click-outside",
    "formly",
    "formlyBootstrap",
    "nsPopover",
    "checklist-model",
    "color.picker",
    "mwl.calendar",
    "angular-svg-round-progressbar",
    "ng-drag-scroll",
    //'agGrid'
  ])
  .run([
    "$rootScope",
    "$location",
    "$cookieStore",
    "$http",
    "TokenInterceptor",
    function ($rootScope, $location, $cookieStore, $http, TokenInterceptor) {
      var freePages = ["/login"];
      $rootScope.requests = [];

      //agGrid.LicenseManager.setLicenseKey('411d3352bf224ca4084f9e42f8dce8b3');
      // keep user logged in after page refresh
      $rootScope.globals = $cookieStore.get("globals") || {};
      if ($rootScope.globals.currentUser) {
        $http.defaults.headers.common["Bearer"] =
          $rootScope.globals.currentUser.token; // jshint ignore:line
        TokenInterceptor.token = $rootScope.globals.currentUser.token;
      }

      $rootScope.$on("$locationChangeStart", function () {
        // redirect to login page if not logged in and trying to access a restricted page
        var restrictedPage = $.inArray($location.path(), freePages) === -1;
        var loggedIn = $rootScope.globals.currentUser;
        if (restrictedPage && !loggedIn) {
          $location.path("/login");
        }
      });
    },
  ])
  .run([
    "$rootScope",
    "$window",
    "$location",
    function ($rootScope, $window, $location) {
      // Function to push the current state
      function pushCurrentState() {
        $window.history.pushState(null, "", $window.location.href);
      }

      //Push the current state when App loads
      pushCurrentState();

      function onPopState(event) {
        if (event.state && event.state.url) {
          // Prevent navigating away from the site
          $window.history.pushState(null, "", $window.location.href);
        }

        if (isFirefox() || isEdge()) {
          history.go(1);
        } else {
          window.history.forward();
        }
      }
      // Add event listener for popstate to prevent navigation
      $window.addEventListener("popstate", onPopState);

      function isFirefox() {
        return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      }

      function isEdge() {
        return navigator.userAgent.toLowerCase().indexOf("edg") > -1;
      }

      $rootScope.$on("$routeChangeSuccess", function () {
        pushCurrentState();
      });

      $rootScope.$on("$locationChangeSuccess", function () {
        pushCurrentState();
      });

      $window.addEventListener("beforeunload", function () {
        $window.removeEventListener("popstate", onPopState);
      });
    },
  ]);
